import { get } from '@kit/utils/APIV1.js'

///cms-service/index.php/wp-json/v1/agency-page/slug/arcata-and-mad-river?pretty
export const page = async(slug) => {
  return get(`agency-page/slug/`+slug)
}
